import { render, staticRenderFns } from "./externalLink.vue?vue&type=template&id=4b7a6a20"
import script from "./externalLink.vue?vue&type=script&lang=js"
export * from "./externalLink.vue?vue&type=script&lang=js"
import style0 from "./externalLink.vue?vue&type=style&index=0&id=4b7a6a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports